import { PureComponent, ReactNode } from 'react';
import auth from '../api/auth';
import { RouteComponentProps } from 'react-router-dom';
import { StaticContext } from 'react-router';
import { track } from '../tracking/mixpanel';
import FullScreenLoader from '../components/FullScreenLoader';
// import { captureErrorV2 } from './captureError';

class LogMeInAndrForward extends PureComponent<
    RouteComponentProps<{ auth: string }, StaticContext, undefined>
> {
    componentDidMount = async (): Promise<void> => {
        const { match, history } = this.props;
        try {
            if (!match.params.auth) {
                track('ERROR', { what: 'No auth code provided', on: 'LogMeInAndrForward' });
                alert('Something went wrong, please try again later. [34]');
                history.goBack();
                return;
            }
            const res = await auth(match.params.auth);
            if (res.status !== 200) {
                throw new Error(
                    'Something went wrong, please try again later. [36] ' + res.error.message,
                );
            }
            // get forward url from query params and redirect
            const url = new URL(window.location.href);
            const forwardUrl = url.searchParams.get('forwardUrl');
            if (!forwardUrl) {
                track('ERROR', { what: 'forwardUrl not found', on: 'LogMeInAndrForward' });
                return;
            }
            history.replace(forwardUrl);
        } catch (err) {
            track('ERROR', { what: (err as Error).message, on: 'LogMeInAndrForward' });
            alert('Something went wrong, please try again later. [35]');
            history.goBack();
            return;
        }
    };

    render(): ReactNode {
        return (
            <div className="w-full h-full">
                <FullScreenLoader />
            </div>
        );
    }
}

export default LogMeInAndrForward;
